export default "__VITE_ASSET__BHCdhO3a__"